import { state, mutations } from './state';
import actions from './actions';
import getters from './getters';

export const iatModule = {
  state,
  mutations,
  actions,
  getters
};

export default iatModule;